import React from 'react'
import ReturnsRefundPolicy from '../components/Return/Return'

const ReturnPage = () => {
  return (
    <div>
        <ReturnsRefundPolicy />
    </div>
  )
}

export default ReturnPage
